import { useMemo } from 'react'
import {
  Button,
  Drawer,
  Table,
} from '@groovehq/internal-design-system/lib/components'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { styles as modalBtnsStyles } from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns.styles'
import ProductsSearch from 'components/integrations/ShopifyV2WidgetCard/ProductsSearch'
import CustomItem from 'components/integrations/ShopifyV2WidgetCard/CustomItem'
import OrderSummary from 'components/integrations/ShopifyV2WidgetCard/OrderSummary'
import { styles } from './styles'

const ShopifyNewOrderModal = ({ onClose, isDuplicate, visible = true }) => {
  const btnDisabled = true
  const footer = useMemo(
    () => {
      return (
        <div css={[modalBtnsStyles.base, styles.footer]}>
          <Button type="primary" disabled={btnDisabled}>
            Create order as paid
          </Button>
          <Button type="primary" disabled={btnDisabled}>
            Create order as pending
          </Button>
          <Button type="tertiary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      )
    },
    [btnDisabled, onClose]
  )

  const priceCurrency = ''
  const handleAddItem = () => {
    // TODO
  }

  const emptyDataColumns = [
    {
      Header: 'Product',
      accessor: 'product',
      width: '70%',
      disableSortBy: true,
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
      disableSortBy: true,
    },
    {
      Header: 'Total',
      accessor: 'total',
      disableSortBy: true,
      width: '25%',
    },
  ]
  const handleInvoiceVisibleChange = () => {
    // TODO
  }

  return (
    <Drawer
      title={`${isDuplicate ? 'Duplicate' : 'Create'} order`}
      footer={footer}
      onClose={onClose}
      open={visible}
      css={text.styles.textDark}
      size="wide"
    >
      <div className="grui flex">
        <ProductsSearch className="grui flex-1" onAddItem={handleAddItem} />
        <CustomItem />
      </div>
      <Table
        columns={emptyDataColumns}
        data={[]}
        loading={false}
        css={[styles.table, styles.empty]}
        className="grui mt-5"
      />
      <OrderSummary
        orderItemsCount={0}
        currency={priceCurrency}
        rawTotal={0}
        onCloseCreateOrder={onClose}
        onSendInvoice={handleInvoiceVisibleChange}
        invoice={{}}
        btnDisabled={btnDisabled}
        className="grui mt-10"
      />
    </Drawer>
  )
}

export default ShopifyNewOrderModal
